'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../../../../styleInject.js');

var css_248z = ".ClaimStatusChip-module_chipContent__qaZ-P{align-items:center;grid-template-columns:1em 1fr}";
var styles = {"chipContent":"ClaimStatusChip-module_chipContent__qaZ-P"};
styleInject["default"](css_248z, '99910b5f-893c-44ba-9f52-eaf411435705');

exports["default"] = styles;
